import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

type TProps = {
  token: string;
};

export const setRedeemVoucher = (state: Draft<IPaymentState>, { payload }: PayloadAction<TProps>) => {
  state.redeemVoucher = {
    token: payload.token,
  };
  state.updatedAt = Date.now();
};
